import { forwardRef } from 'react';
// Fixes forward ref with generics, source https://www.totaltypescript.com/forwardref-with-generic-components
export function genericForwardRef(render) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return forwardRef(render);
}
